import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Userpilot } from 'userpilot';
import { filter } from 'rxjs/operators';
import { FeatureService } from '@core/feature/feature.service';
import { FEATURE_FLAGS } from '@core/feature/feature.constants';
import { SecurityManagerService } from '@core/security-manager/security-manager.service';

@Injectable({
	providedIn: 'root',
})
export class UserpilotService {

	private featureService = inject(FeatureService);
	private securityManagerService = inject(SecurityManagerService);
	private router = inject(Router);

	initialize() {
		if (this.featureService.isFeatureOff(FEATURE_FLAGS.FEATURES.USERPILOT)) {
			return;
		}

		const token = window.__ENV_CONFIG__?.userpilotToken;
		if (!token) {
			return;
		}

		try {
			Userpilot.initialize(token);

			const session = this.securityManagerService.getUserSession();
			const userId = String(session.userEntityId);
			Userpilot.identify(userId, {
				name: session.userFullName,
				email: session.userEmail,
				created_at: session.userCreatedDate,
				is_provider: this.securityManagerService.userIsProvider(),
				tenant: window.__ENV_CONFIG__?.userpilotTenantIdentifier,
				company: {
					id: session.practiceId,
					name: session.practiceName,
					...(session.practiceCreatedDate && { created_at: session.practiceCreatedDate }),
				},
			});

			this.router.events.pipe(
				filter(event => event instanceof NavigationEnd),
			).subscribe(() => {
				Userpilot.reload();
			});
		} catch (e) {
			console.error('[Userpilot] Failed to initialize:', e);
		}
	}
}
